/** Mesmo código do BFF (server/lib/credit-guard.ts): 402 no pre-check ou chunk de erro no stream. */
export const AI_CREDITS_EXHAUSTED = 'AI_CREDITS_EXHAUSTED';

export const CREDITS_EXHAUSTED_MESSAGE =
  'Seus créditos de IA acabaram. Fale com o administrador para liberar mais créditos.';

export function isCreditsExhaustedError(error: unknown): boolean {
  if (!error) return false;
  const message = error instanceof Error ? error.message : String(error);
  return message.includes(AI_CREDITS_EXHAUSTED);
}
